import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
const TTL_MS = 60 * 60 * 1000;
const PERSIST_NAME = 'tasks-drawer';
function namespaceKeyFor(userId, businessId) {
    return userId && businessId ? "tasks:".concat(userId, ":").concat(businessId) : null;
}
function isExpired(updatedAt) {
    return updatedAt > 0 && Date.now() - updatedAt > TTL_MS;
}
export const useTasksDrawerStore = create()(persist((set, get)=>({
        namespaceKey: null,
        tasks: [],
        updatedAt: 0,
        setActiveNamespace: (userId, businessId)=>{
            const next = namespaceKeyFor(userId, businessId);
            if (next === get().namespaceKey) return;
            set({
                namespaceKey: next,
                tasks: [],
                updatedAt: 0
            });
        },
        addTask: (task)=>{
            if (get().namespaceKey == null) return;
            set((s)=>({
                    tasks: [
                        task,
                        ...s.tasks.filter((t)=>t.jobId !== task.jobId)
                    ],
                    updatedAt: Date.now()
                }));
        },
        updateTask: (jobId, patch)=>{
            if (get().namespaceKey == null) return;
            set((s)=>({
                    tasks: s.tasks.map((t)=>t.jobId === jobId ? _object_spread({}, t, patch) : t),
                    updatedAt: Date.now()
                }));
        },
        removeTask: (jobId)=>{
            if (get().namespaceKey == null) return;
            const before = get().tasks;
            const after = before.filter((t)=>t.jobId !== jobId);
            if (after.length === before.length) return;
            set({
                tasks: after,
                updatedAt: Date.now()
            });
        }
    }), {
    name: PERSIST_NAME,
    version: 1,
    storage: createJSONStorage(()=>localStorage),
    partialize: (state)=>({
            namespaceKey: state.namespaceKey,
            tasks: state.tasks,
            updatedAt: state.updatedAt
        }),
    onRehydrateStorage: ()=>(state)=>{
            if (state && isExpired(state.updatedAt)) {
                state.tasks = [];
                state.updatedAt = 0;
            }
        }
}));
export function useActiveTasks() {
    return useTasksDrawerStore((s)=>s.tasks);
}
export const tasksStore = {
    addTask: (task)=>useTasksDrawerStore.getState().addTask(task),
    updateTask: (jobId, patch)=>useTasksDrawerStore.getState().updateTask(jobId, patch),
    removeTask: (jobId)=>useTasksDrawerStore.getState().removeTask(jobId),
    getSnapshotTasks: ()=>useTasksDrawerStore.getState().tasks
};
export function setActiveNamespace(userId, businessId) {
    useTasksDrawerStore.getState().setActiveNamespace(userId, businessId);
}
export function __resetForTesting__() {
    useTasksDrawerStore.setState({
        namespaceKey: null,
        tasks: [],
        updatedAt: 0
    });
}
